"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem,
    scrollProps
  } = (0, _hooks.useStylesUtils)();
  const ccModalContentStyle = (0, _react.useMemo)(() => {
    const mobileProps = () => {
      const margin = isMobileView ? `${pxToRem(8)} ${pxToRem(10)} ${pxToRem(17)}` : `${pxToRem(8)} ${pxToRem(15)} ${pxToRem(17)}`;
      const padding = isMobileView ? pxToRem(10) : `0 ${pxToRem(15)}`;
      const minHeight = isMobileView ? 'auto' : pxToRem(160);
      return {
        margin,
        padding,
        minHeight
      };
    };
    const ccModalContent = (0, _css.css)({
      position: 'relative',
      height: '100%',
      overflow: 'auto',
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      ...mobileProps(),
      ...scrollProps()
    });
    return ccModalContent;
  }, [isMobileView, pxToRem, scrollProps]);
  return {
    'cc-ModalContent': ccModalContentStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;